import {HttpClient} from '@angular/common/http';

export type TStartPos = {x: number, y: number, dir: string};
export interface ILevelBase {
  walls?: string;
  start?: TStartPos;
}

export class Level<LevelType extends ILevelBase> {
  private canvas: HTMLCanvasElement;
  private context: CanvasRenderingContext2D;
  info: LevelType;

  constructor(public level: string) {
    this.canvas = document.createElement('canvas');
    this.context = this.canvas.getContext('2d');
  }

  get src(): string {
    return this.info ? `/assets/levels/${this.info.walls || (this.level + '.png')}` : null;
  }

  get json(): string {
    return `/assets/levels/${this.level}.json`;
  }

  async load(httpClient: HttpClient): Promise<void> {
    this.info = (await httpClient.get(this.json)
        .toPromise()) as LevelType;
    const img = document.createElement('img');
    img.src = this.src;
    await new Promise((resolve) => img.onload = resolve);
    this.canvas.width = img.width;
    this.canvas.height = img.height;
    this.context.drawImage(img, 0, 0);
  }

  get width(): number { return this.canvas.width; }
  get height(): number { return this.canvas.height; }

  // noinspection JSUnusedGlobalSymbols
  public pixel(x: number, y: number): Uint8Array {
    return new Uint8Array(this.context.getImageData(x, y, 1, 1).data);
  }
}
